import dayjs from 'dayjs';

import { getBaseUrl } from '@services/api';

import type { GameBuild } from './client-miner.types';

export const getEndEditDate = (
  activateDate: Date | null,
  editDayCount: number
) => dayjs(activateDate).add(editDayCount, 'day').format('DD/MM/YYYY HH:mm:ss');

export const getEndGameDate = (
  activateDate: Date | null,
  gameDayCount: number
) => dayjs(activateDate).add(gameDayCount, 'day').format('DD/MM/YYYY HH:mm:ss');

export const getIsClientFormDisabled = (
  activateDate: Date | null,
  editDayCount: number
) => {
  if (activateDate === null) {
    return false;
  }

  return dayjs(activateDate).add(editDayCount, 'day').isBefore(dayjs());
};

const publicBaseUrl = getBaseUrl().replace(/\/api$/, '');

export const generateGameLink = (buildId: string, isTesting: boolean) => {
  return `${publicBaseUrl}/game?buildId=${buildId}${
    isTesting ? '&isTesting=true' : ''
  }`;
}; 